<script setup lang="ts">
import { MetricValue } from '@Shared/utils/types';
import ValueTile from './parts/ValueTile.vue';

const props = defineProps<{
  title?: string;
  isLoadingIndicator?: boolean;
  metricValue?: MetricValue;
}>();

const { metricValue } = toRefs(props);
</script>
<template>
  <ValueTile :loading="isLoadingIndicator" :title="title" :scores="metricValue ? [metricValue] : []">
    <template #header>
      <!-- This is purely so that it omits the headers -->
      <span></span
    ></template>
    <template #data="{ value }">
      <span class="text-[32px] xl:text-[40px]">{{ value }}</span>
    </template>
  </ValueTile>
</template>
